import support from '../../services/support';
import messageDialog from '../../components/message-dialog.vue'

const subject = [{
    value: '1',
    valueId: '1',
    caption: 'Vale Pedágio'
  },
  {
    value: '2',
    valueId: '3',
    caption: 'Adesão a Planos'
  },
  {
    value: '3',
    valueId: '3',
    caption: 'Compra de Tag'
  },
  {
    value: '4',
    valueId: '3',
    caption: 'Problema com Cobrança'
  },
  {
    value: '5',
    valueId: '4',
    caption: 'Problema com Tag'
  },
  {
    value: '6',
    valueId: '5',
    caption: 'Dúvida'
  },
  {
    value: '7',
    valueId: '6',
    caption: 'Elogio'
  },
  {
    value: '8',
    valueId: '7',
    caption: 'Marketing'
  },
];

export default {
  data() {
    return {
      faleConosco:{},
      formState: 'NEW',
      errorMessage: '',
      subject,
      subjects: '1',
      loading: undefined
    }
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    doRequest() {
      this.formState = 'NEW';
      this.$validator.validateAll()
        .then(success => {
          this.faleConosco.assunto = subject.find(s => s.value == this.faleConosco.assuntoId).caption;
          this.faleConosco.assuntoId = subject.find(s => s.value == this.faleConosco.assuntoId).valueId;
          this.loading = support.faleConosco(this.faleConosco)
            .then(data => {
              if (data) this.formState = 'SUCCESS';
            })
            .catch(err => {
              this.formState = 'ERROR';
              this.errorMessage = err.data && err.data.status && err.data.status.message || "Ocorreu um erro, por favor tente novamente";
            });
        });

    },
  },
  components: {}
}



// WEBPACK FOOTER //
// ./src/pages/external/contact.js